module.exports = __webpack_public_path__ + "img/八分之三相.984f926b.svg";